/**
 * WhatsApp Business number (GD-44). Shared by every brand variant in this app —
 * there is one WABA ("Prepaid") behind all three domains, unlike the
 * travel dashboard where each brand has its own number.
 * `wa.me` requires digits only, no `+` or spaces.
 */
export const WHATSAPP_LINK = "https://wa.me/447441442615";

export const PHONE_NUMBERS = [
  { countryCode: "GB", phone: "+44 2035142250", href: "tel:+442035142250" },
  { countryCode: "FR", phone: "+33 1 89 76 01 81", href: "tel:+33189760181" },
  { countryCode: "DE", phone: "0800 1809031", href: "tel:08001809031" },
] as const;
